import { useAtom } from 'jotai';
import { userTokenAtom } from './../atoms'; // replace with the actual path

export function useUserToken() {
  const [userToken, setUserToken] = useAtom(userTokenAtom);
  return [userToken, setUserToken];
}
